import { render } from "./addSyndrome.vue?vue&type=template&id=f1a811fa&scoped=true"
import script from "./addSyndrome.vue?vue&type=script&lang=js"
export * from "./addSyndrome.vue?vue&type=script&lang=js"

import "./addSyndrome.vue?vue&type=style&index=0&id=f1a811fa&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a811fa"]])

export default __exports__